import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";


const commonBanner = (clientAssetsLink: any) => {
    return (
        <div className="banner-wrapper" style={{ backgroundImage: `url("${clientAssetsLink + "/careers-bg.png"}` }}>
            {/* abs img on right */}
            <div className="banner-image-absolute">
                <img src={clientAssetsLink + "/careers-image.png"} alt="Careers Banner" />
            </div>
            <div className="banner-content container mx-auto" >
                <div className="banner-text">
                    <h1 className="blue-text">Careers</h1>
                    <p className="grey-text">{"Build your career in high-performing teams."}</p>
                </div>
            </div>
        </div>
    );
};

const registerBanner = (clientAssetsLink: any) => {
    return (
        <div className="register-banner-wrapper" style={{ backgroundImage: `url("${clientAssetsLink + "/Join Our Team Page - Hero Banner - BG Image.jpg"}` }}>
            <div className="banner-content container mx-auto d-flex" >
                <div className="banner-text">
                    <h1>Join the Equity Connect Outsourced Talent Network</h1>
                    <p>{"We’re always looking for skilled professionals to join the Equity Connect Outsourced team. Share your details below to be considered for upcoming opportunities."}</p>
                </div>
                <hr />
                <div className="banner-cta equity-header-scope">
                    <h3 className="elementor-heading-title elementor-size-default">Looking to Hire Talent?</h3>
                    <div
                        className="elementor-element elementor-element-6a7e1912 btn-icon elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-button"
                        data-id="6a7e1912"
                        data-element_type="widget"
                        data-widget_type="button.default"
                    >
                        <a
                            className="elementor-button elementor-button-link elementor-size-sm"
                            href="https://ecoutsourced.com/hire-talent/"
                        >
                            <span className="elementor-button-content-wrapper">
                                <span className="elementor-button-text book-call-color">Hire Talent</span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};


const EquityBanner = ({ isRegisterPage }: any) => {
    const { clientAssetsLink } = useClientConfig();
    return (
        isRegisterPage ? registerBanner(clientAssetsLink) : commonBanner(clientAssetsLink)
    );
};

export default EquityBanner;
